
export default
[
    { text: 'Sampled before oil change', value: 'BEFORE' },
    { text: 'Sampled after oil change', value: 'AFTER' },
    { text: 'Unknown or not applicable', value: 'UNKNOWN' }
];